import { defineStore } from 'pinia';

// eslint-disable-next-line import/prefer-default-export
export const useCustomizationStore = defineStore('customizationStore', {
    state: () => ({
        customCss: null,
    }),
    actions: {
        setCustomCss(cssData)
        {
            this.customCss = cssData;
        },
    },
});
